import { render, staticRenderFns } from "./BankAccounts.vue?vue&type=template&id=08834f9c"
import script from "./BankAccounts.vue?vue&type=script&lang=ts"
export * from "./BankAccounts.vue?vue&type=script&lang=ts"
import style0 from "./BankAccounts.vue?vue&type=style&index=0&id=08834f9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports